import { OfferModuleWrapperView } from './OfferModuleWrapperView';

const OfferModuleWrapperController = ({ isOfferError, ...props }) => {
  return <OfferModuleWrapperView isOfferError={isOfferError} {...props} />;
};

export { OfferModuleWrapperController as OfferModuleWrapper };
